import { ReactNode } from 'react';

// https://legacy.reactjs.org/docs/jsx-in-depth.html#booleans-null-and-undefined-are-ignored
export const getIsRenderable = (
	node: ReactNode
): node is Exclude<ReactNode, boolean | null | undefined> =>
	!(typeof node === 'boolean' || node == null);
